export default {
    CENTER: "CENTER",
    BOTTOM: "BOTTOM",
    TOP: "TOP"
}
